import { render, staticRenderFns } from "./PackageDistribution.vue?vue&type=template&id=51155790"
import script from "./PackageDistribution.vue?vue&type=script&lang=js"
export * from "./PackageDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports